
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.336 7.54l2.758 6.062L9.954.266h1.6v1.039h-1.023l-4.203 14.36H5.57L2.336 8.71l-1.32.586-.243-.586 2.563-1.172zm.57-1.126c.23-.042.383-.088.461-.14a.412.412 0 00.164-.235c.037-.11.055-.302.055-.578v-.602H1.562v-.421L4.728.226h.906v4.039h.094c.203 0 .349-.016.437-.047a.48.48 0 00.227-.18c.062-.083.117-.21.164-.383h.492l-.07 1.203H5.633v.602c0 .281.018.476.054.586.037.11.1.19.188.242.089.047.234.089.438.125v.352H3.905v-.352zm-1.32-2.148h2v-.93c0-.23.005-.529.016-.898.01-.376.026-.69.046-.946h-.07L2.586 4.203v.063z","fill":"currentColor"}})])
          )
        }
      }
    